import { css } from "@emotion/react";

export const form = css`
  width: 100%;
`;
